import React from 'react';

const SlideTwo = () => {
	return <div>SlideTwo</div>;
};

export default SlideTwo;
